export const teams = [
  {
    id: 'neo-tokyo',
    name: 'Neo Tokyo Thunder',
    abbreviation: 'NT',
    city: 'Tokyo',
    color: '#ff0066',
    league: 'National League',
    venue: 'Tokyo Dome',
    volatility: 17,
    pace: 14, // Fast-paced team (0-20 scale)
    shotPreference: 12, // Slight preference for 25s (0=all 10s, 10=50/50, 20=all 25s)
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'nt-p1',
        name: 'Kenji Nakamura',
        position: 1,
        reaction: 13, // role
        tactics: 16, // star
        focus: 10, // role
        usage: 1.3,
        age: 28,
        potential: 14,
        tendencies: { points: 13, rebounds: 7, assists: 15 },
        mech: {
          class: 'SUPPORT',
          model: 'HEXAGON-ARC7.SUPPORT',
          manufacturer: 'Hexagon Dynamics',
          targeting: 13, // role
          servoResponse: 16, // superstar
          jumpJets: 9, // minor weakness
          armor: 9, // minor weakness
          heatManagement: 12, // role
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'nt-p2',
        name: 'Yuki Tanaka',
        position: 2,
        reaction: 14, // role
        tactics: 12, // role
        focus: 18, // superstar
        usage: 1.7,
        age: 25,
        potential: 18,
        tendencies: { points: 18, rebounds: 7, assists: 10 },
        mech: {
          class: 'SNIPER',
          model: 'HEXAGON-ARC7.SNIPER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 19, // superstar
          servoResponse: 13, // role
          jumpJets: 10, // minor weakness
          armor: 8, // minor weakness
          heatManagement: 15, // star
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'nt-p3',
        name: 'Hiro Sato',
        position: 3,
        reaction: 12, // role
        tactics: 12, // role
        focus: 12, // role
        usage: 1.0,
        age: 30,
        potential: 10,
        tendencies: { points: 12, rebounds: 8, assists: 8 },
        mech: {
          class: 'INFILTRATOR',
          model: 'MERIDIAN-COMPASS3.INFILTRATOR',
          manufacturer: 'Meridian Systems',
          targeting: 15, // star
          servoResponse: 12, // role
          jumpJets: 13, // role
          armor: 8, // minor weakness
          heatManagement: 11, // role
          wear: 7,
          durability: 18
        }
      },
      {
        id: 'nt-p4',
        name: 'Kenji Yamamoto',
        position: 4,
        reaction: 11, // role
        tactics: 10, // role
        focus: 9, // minor weakness
        usage: 0.8,
        age: 22,
        potential: 15,
        tendencies: { points: 7, rebounds: 13, assists: 7 },
        mech: {
          class: 'GUARDIAN',
          model: 'MERIDIAN-HEADING5.GUARDIAN',
          manufacturer: 'Meridian Systems',
          targeting: 10, // role
          servoResponse: 11, // role
          jumpJets: 13, // role
          armor: 7, // minor weakness
          heatManagement: 10, // role
          wear: 5,
          durability: 2
        }
      },
      {
        id: 'nt-p5',
        name: 'Takeshi Kobayashi',
        position: 5,
        reaction: 10, // role
        tactics: 9, // minor weakness
        focus: 10, // role
        usage: 0.7,
        age: 29,
        potential: 12,
        tendencies: { points: 8, rebounds: 12, assists: 6 },
        mech: {
          class: 'ASSAULT',
          model: 'HEXAGON-PIER4.ASSAULT',
          manufacturer: 'Hexagon Dynamics',
          targeting: 11, // role
          servoResponse: 10, // role
          jumpJets: 12, // role
          armor: 7, // minor weakness
          heatManagement: 10, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  },
  {
    id: 'berlin',
    name: 'Berlin Steel',
    abbreviation: 'BS',
    city: 'Berlin',
    color: '#00ff88',
    league: 'National League',
    venue: 'Olympiastadion Berlin',
    volatility: 4,
    pace: 8, // Slower, methodical team
    shotPreference: 16, // Prefers long-range 25s
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'ber-p1',
        name: 'Klaus Weber',
        position: 1,
        reaction: 12, // role
        tactics: 14, // star
        focus: 10, // role
        usage: 1.1,
        age: 26,
        potential: 17,
        tendencies: { points: 8, rebounds: 10, assists: 12 },
        mech: {
          class: 'COMMANDER',
          model: 'FULCRUM-BEAM1.COMMANDER',
          manufacturer: 'Fulcrum Industries',
          targeting: 10, // minor weakness
          servoResponse: 13, // role
          jumpJets: 9, // minor weakness
          armor: 13, // star
          heatManagement: 11, // role
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'ber-p2',
        name: 'Elena Kowalski',
        position: 2,
        reaction: 11, // role
        tactics: 10, // role
        focus: 13, // role
        usage: 1.0,
        age: 24,
        potential: 14,
        tendencies: { points: 9, rebounds: 9, assists: 8 },
        mech: {
          class: 'STRIKER',
          model: 'TANGENT-SINE2.STRIKER',
          manufacturer: 'Tangent Corporation',
          targeting: 10, // minor weakness
          servoResponse: 10, // role
          jumpJets: 10, // role
          armor: 13, // star
          heatManagement: 11, // role
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'ber-p3',
        name: 'Viktor Schmidt',
        position: 3,
        reaction: 12, // role
        tactics: 12, // role
        focus: 10, // role
        usage: 0.9,
        age: 28,
        potential: 11,
        tendencies: { points: 8, rebounds: 11, assists: 8 },
        mech: {
          class: 'PHANTOM',
          model: 'FULCRUM-STRUT3.PHANTOM',
          manufacturer: 'Fulcrum Industries',
          targeting: 10, // minor weakness
          servoResponse: 12, // role
          jumpJets: 12, // role
          armor: 14, // star
          heatManagement: 10, // role
          wear: 7,
          durability: 18
        }
      },
      {
        id: 'ber-p4',
        name: 'Dieter Krause',
        position: 4,
        reaction: 10, // role
        tactics: 9, // minor weakness
        focus: 11, // role
        usage: 0.8,
        age: 23,
        potential: 13,
        tendencies: { points: 7, rebounds: 12, assists: 7 },
        mech: {
          class: 'ENFORCER',
          model: 'TANGENT-DELTA4.ENFORCER',
          manufacturer: 'Tangent Corporation',
          targeting: 10, // minor weakness
          servoResponse: 11, // role
          jumpJets: 11, // role
          armor: 13, // star
          heatManagement: 9, // minor weakness
          wear: 5,
          durability: 2
        }
      },
      {
        id: 'ber-p5',
        name: 'Franz Bauer',
        position: 5,
        reaction: 11, // role
        tactics: 10, // role
        focus: 12, // role
        usage: 0.8,
        age: 27,
        potential: 16,
        tendencies: { points: 8, rebounds: 13, assists: 6 },
        mech: {
          class: 'FORTRESS',
          model: 'FULCRUM-GIRDER5.FORTRESS',
          manufacturer: 'Fulcrum Industries',
          targeting: 10, // minor weakness
          servoResponse: 10, // role
          jumpJets: 13, // role
          armor: 14, // star
          heatManagement: 10, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  },
  // Lagos Lightning (A tier):
  {
    id: 'lagos',
    name: 'Lagos Lightning',
    abbreviation: 'LL',
    city: 'Lagos',
    color: '#ffaa00',
    league: 'National League',
    venue: 'Eko Convention Centre',
    volatility: 10,
    pace: 16, // High tempo team
    shotPreference: 6, // Prefers close-range 10s
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'lag-p1',
        name: 'Kwame Asante',
        position: 1,
        reaction: 18, // superstar
        tactics: 14, // star
        focus: 12, // role
        usage: 1.5,
        age: 29,
        potential: 16,
        tendencies: { points: 15, rebounds: 7, assists: 14 },
        mech: {
          class: 'BLITZ',
          model: 'PARALLAX-LENS1.BLITZ',
          manufacturer: 'Parallax Enterprises',
          targeting: 16, // star
          servoResponse: 15, // star
          jumpJets: 10, // minor weakness
          armor: 10, // role
          heatManagement: 13, // role
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'lag-p2',
        name: 'Adanna Okafor',
        position: 2,
        reaction: 14, // star
        tactics: 12, // role
        focus: 15, // star
        usage: 1.2,
        age: 26,
        potential: 14,
        tendencies: { points: 14, rebounds: 6, assists: 12 },
        mech: {
          class: 'SENTINEL',
          model: 'VERTEX-ALPHA2.SENTINEL',
          manufacturer: 'Vertex Solutions',
          targeting: 16, // star
          servoResponse: 13, // role
          jumpJets: 11, // role
          armor: 10, // role
          heatManagement: 13, // role
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'lag-p3',
        name: 'Emeka Nwosu',
        position: 3,
        reaction: 13, // role
        tactics: 14, // star
        focus: 12, // role
        usage: 1.0,
        age: 25,
        potential: 12,
        tendencies: { points: 12, rebounds: 10, assists: 8 },
        mech: {
          class: 'RANGER',
          model: 'PARALLAX-SCOPE3.RANGER',
          manufacturer: 'Parallax Enterprises',
          targeting: 14, // star
          servoResponse: 13, // role
          jumpJets: 15, // star
          armor: 10, // role
          heatManagement: 11, // role
          wear: 7,
          durability: 18
        }
      },
      {
        id: 'lag-p4',
        name: 'Tunde Okonkwo',
        position: 4,
        reaction: 11, // role
        tactics: 10, // role
        focus: 9, // minor weakness
        usage: 0.8,
        age: 24,
        potential: 13,
        tendencies: { points: 8, rebounds: 13, assists: 7 },
        mech: {
          class: 'ARTILLERY',
          model: 'VERTEX-THETA4.ARTILLERY',
          manufacturer: 'Vertex Solutions',
          targeting: 12, // role
          servoResponse: 11, // role
          jumpJets: 13, // role
          armor: 14, // star
          heatManagement: 10, // role
          wear: 5,
          durability: 2
        }
      },
      {
        id: 'lag-p5',
        name: 'Biodun Alade',
        position: 5,
        reaction: 12, // role
        tactics: 9, // minor weakness
        focus: 12, // role
        usage: 0.7,
        age: 27,
        potential: 14,
        tendencies: { points: 9, rebounds: 14, assists: 6 },
        mech: {
          class: 'DESTROYER',
          model: 'PARALLAX-FILTER5.DESTROYER',
          manufacturer: 'Parallax Enterprises',
          targeting: 12, // role
          servoResponse: 11, // role
          jumpJets: 13, // role
          armor: 16, // star
          heatManagement: 12, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  },
  // São Paulo Surge (A/B tier):
  {
    id: 'sao-paulo',
    name: 'São Paulo Surge',
    abbreviation: 'SP',
    city: 'São Paulo',
    color: '#00aaff',
    league: 'National League',
    venue: 'Allianz Parque',
    volatility: 15,
    pace: 13, // Fast-paced offensive team
    shotPreference: 8, // Prefers 10-point shots
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'sp-p1',
        name: 'Isabella Santos',
        position: 1,
        reaction: 13, // role
        tactics: 18, // superstar
        focus: 12, // role
        usage: 1.4,
        age: 26,
        potential: 15,
        tendencies: { points: 14, rebounds: 7, assists: 16 },
        mech: {
          class: 'SUPPORT',
          model: 'TESSELLATE-PRISM1.SUPPORT',
          manufacturer: 'Tessellate Holdings',
          targeting: 15, // star
          servoResponse: 13, // role
          jumpJets: 10, // minor weakness
          armor: 8, // minor weakness
          heatManagement: 13, // role
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'sp-p2',
        name: 'Carlos Mendes',
        position: 2,
        reaction: 14, // star
        tactics: 12, // role
        focus: 15, // star
        usage: 1.2,
        age: 28,
        potential: 16,
        tendencies: { points: 16, rebounds: 6, assists: 12 },
        mech: {
          class: 'SNIPER',
          model: 'HEXAGON-ARC7.SNIPER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 16, // star
          servoResponse: 13, // role
          jumpJets: 11, // role
          armor: 8, // minor weakness
          heatManagement: 13, // role
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'sp-p3',
        name: 'Rafael Silva',
        position: 3,
        reaction: 13, // role
        tactics: 14, // star
        focus: 12, // role
        usage: 1.0,
        age: 27,
        potential: 13,
        tendencies: { points: 13, rebounds: 10, assists: 8 },
        mech: {
          class: 'INFILTRATOR',
          model: 'TESSELLATE-WEDGE3.INFILTRATOR',
          manufacturer: 'Tessellate Holdings',
          targeting: 14, // star
          servoResponse: 13, // role
          jumpJets: 13, // role
          armor: 8, // minor weakness
          heatManagement: 11, // role
          wear: 14,
          durability: 10
        }
      },
      {
        id: 'sp-p4',
        name: 'Mariana Oliveira',
        position: 4,
        reaction: 11, // role
        tactics: 10, // role
        focus: 9, // minor weakness
        usage: 0.8,
        age: 25,
        potential: 14,
        tendencies: { points: 8, rebounds: 13, assists: 7 },
        mech: {
          class: 'GUARDIAN',
          model: 'HEXAGON-PIER4.GUARDIAN',
          manufacturer: 'Hexagon Dynamics',
          targeting: 12, // role
          servoResponse: 11, // role
          jumpJets: 13, // role
          armor: 8, // minor weakness
          heatManagement: 10, // role
          wear: 14,
          durability: 10
        }
      },
      {
        id: 'sp-p5',
        name: 'Pedro Almeida',
        position: 5,
        reaction: 12, // role
        tactics: 9, // minor weakness
        focus: 12, // role
        usage: 0.7,
        age: 29,
        potential: 14,
        tendencies: { points: 10, rebounds: 14, assists: 6 },
        mech: {
          class: 'ASSAULT',
          model: 'TESSELLATE-FRAME5.ASSAULT',
          manufacturer: 'Tessellate Holdings',
          targeting: 12, // role
          servoResponse: 11, // role
          jumpJets: 13, // role
          armor: 8, // minor weakness
          heatManagement: 12, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  },
  // Montreal Frost (B tier):
  {
    id: 'montreal',
    name: 'Montreal Frost',
    abbreviation: 'MF',
    city: 'Montreal',
    color: '#ff00ff',
    league: 'National League',
    venue: 'Stade Olympique',
    volatility: 6,
    pace: 10, // Exactly average pace
    shotPreference: 10, // Perfect 50/50 split
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'mon-p1',
        name: 'Jean-Luc Dubois',
        position: 1,
        reaction: 13, // role
        tactics: 17, // superstar
        focus: 11, // role
        usage: 1.3,
        age: 28,
        potential: 15,
        tendencies: { points: 13, rebounds: 7, assists: 16 },
        mech: {
          class: 'COMMANDER',
          model: 'HEXAGON-ARC7.COMMANDER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 15, // star
          servoResponse: 13, // role
          jumpJets: 10, // minor weakness
          armor: 10, // role
          heatManagement: 12, // role
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'mon-p2',
        name: 'Marie Tremblay',
        position: 2,
        reaction: 13, // role
        tactics: 12, // role
        focus: 15, // star
        usage: 1.2,
        age: 26,
        potential: 16,
        tendencies: { points: 15, rebounds: 6, assists: 10 },
        mech: {
          class: 'STRIKER',
          model: 'HEXAGON-ARC7.STRIKER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 16, // star
          servoResponse: 13, // role
          jumpJets: 11, // role
          armor: 10, // role
          heatManagement: 13, // role
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'mon-p3',
        name: 'Antoine Roy',
        position: 3,
        reaction: 12, // role
        tactics: 14, // star
        focus: 12, // role
        usage: 1.0,
        age: 27,
        potential: 14,
        tendencies: { points: 11, rebounds: 10, assists: 8 },
        mech: {
          class: 'PHANTOM',
          model: 'HEXAGON-ARC7.PHANTOM',
          manufacturer: 'Hexagon Dynamics',
          targeting: 13, // role
          servoResponse: 13, // role
          jumpJets: 13, // role
          armor: 10, // role
          heatManagement: 11, // role
          wear: 14,
          durability: 10
        }
      },
      {
        id: 'mon-p4',
        name: 'Isabelle Roy',
        position: 4,
        reaction: 11, // role
        tactics: 10, // role
        focus: 9, // minor weakness
        usage: 0.9,
        age: 25,
        potential: 15,
        tendencies: { points: 7, rebounds: 13, assists: 7 },
        mech: {
          class: 'ENFORCER',
          model: 'HEXAGON-ARC7.ENFORCER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 12, // role
          servoResponse: 11, // role
          jumpJets: 13, // role
          armor: 14, // star
          heatManagement: 10, // role
          wear: 14,
          durability: 10
        }
      },
      {
        id: 'mon-p5',
        name: 'Pierre Gagnon',
        position: 5,
        reaction: 12, // role
        tactics: 9, // minor weakness
        focus: 12, // role
        usage: 0.8,
        age: 28,
        potential: 16,
        tendencies: { points: 9, rebounds: 14, assists: 6 },
        mech: {
          class: 'FORTRESS',
          model: 'HEXAGON-ARC7.FORTRESS',
          manufacturer: 'Hexagon Dynamics',
          targeting: 12, // role
          servoResponse: 11, // role
          jumpJets: 13, // role
          armor: 16, // star
          heatManagement: 12, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  },
  // Hexagon Dynamics Corp (A tier):
  {
    id: 'hexagon-dynamics',
    name: 'Hexagon Dynamics Corp',
    abbreviation: 'HD',
    city: 'Corporate',
    color: '#00e6e6',
    league: 'Corporate League',
    venue: 'Hexagon Arena',
    volatility: 6,
    pace: 9, // Controlled, efficient pace
    shotPreference: 15, // Strong preference for 25s
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'hd-p1',
        name: '[RDCTD]-A7',
        position: 1,
        reaction: 15, // star
        tactics: 17, // superstar
        focus: 13, // role
        usage: 1.4,
        age: 29,
        potential: 15,
        tendencies: { points: 15, rebounds: 8, assists: 15 },
        mech: {
          class: 'COMMANDER',
          model: 'HEXAGON-ARC9.COMMANDER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 16, // star
          servoResponse: 14, // star
          jumpJets: 10, // minor weakness
          armor: 10, // role
          heatManagement: 15, // star
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'hd-p2',
        name: '[RDCTD]-B2',
        position: 2,
        reaction: 14, // star
        tactics: 13, // role
        focus: 15, // star
        usage: 1.3,
        age: 27,
        potential: 16,
        tendencies: { points: 14, rebounds: 6, assists: 10 },
        mech: {
          class: 'SNIPER',
          model: 'HEXAGON-ARC9.SNIPER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 16, // star
          servoResponse: 13, // role
          jumpJets: 11, // role
          armor: 10, // role
          heatManagement: 14, // role
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'hd-p3',
        name: '[RDCTD]-C4',
        position: 3,
        reaction: 13, // role
        tactics: 13, // role
        focus: 12, // role
        usage: 1.0,
        age: 26,
        potential: 13,
        tendencies: { points: 10, rebounds: 8, assists: 7 },
        mech: {
          class: 'PHANTOM',
          model: 'HEXAGON-ARC9.PHANTOM',
          manufacturer: 'Hexagon Dynamics',
          targeting: 13, // role
          servoResponse: 14, // role
          jumpJets: 13, // role
          armor: 10, // role
          heatManagement: 12, // role
          wear: 7,
          durability: 18
        }
      },
      {
        id: 'hd-p4',
        name: '[RDCTD]-D9',
        position: 4,
        reaction: 12, // role
        tactics: 13, // role
        focus: 11, // role
        usage: 0.8,
        age: 25,
        potential: 14,
        tendencies: { points: 7, rebounds: 15, assists: 6 },
        mech: {
          class: 'ENFORCER',
          model: 'HEXAGON-ARC9.ENFORCER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 12, // role
          servoResponse: 12, // role
          jumpJets: 12, // role
          armor: 16, // star
          heatManagement: 11, // role
          wear: 5,
          durability: 2
        }
      },
      {
        id: 'hd-p5',
        name: '[RDCTD]-E1',
        position: 5,
        reaction: 11, // role
        tactics: 10, // minor weakness
        focus: 12, // role
        usage: 0.7,
        age: 28,
        potential: 16,
        tendencies: { points: 8, rebounds: 16, assists: 5 },
        mech: {
          class: 'FORTRESS',
          model: 'HEXAGON-ARC9.FORTRESS',
          manufacturer: 'Hexagon Dynamics',
          targeting: 10, // role
          servoResponse: 10, // role
          jumpJets: 13, // role
          armor: 17, // star
          heatManagement: 12, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  },
  // Parse Analytics Corp (middle-of-the-road stats):
  {
    id: 'parse-analytics',
    name: 'Parse Analytics Corp',
    abbreviation: 'PA',
    city: 'Corporate',
    color: '#00bfff',
    league: 'Corporate League',
    venue: 'Parse Analytics Arena',
    volatility: 14,
    pace: 12, // Above average pace
    shotPreference: 13, // Prefers 25s
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'pa-p1',
        name: '[RDCTD]-A3',
        position: 1,
        reaction: 12, // role
        tactics: 13, // role
        focus: 12, // role
        usage: 1.2,
        age: 27,
        potential: 16,
        tendencies: { points: 12, rebounds: 7, assists: 13 },
        mech: {
          class: 'COMMANDER',
          model: 'MERIDIAN-VECTOR1.COMMANDER',
          manufacturer: 'Meridian Systems',
          targeting: 13, // role
          servoResponse: 12, // role
          jumpJets: 11, // role
          armor: 11, // role
          heatManagement: 12, // role
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'pa-p2',
        name: '[RDCTD]-B8',
        position: 2,
        reaction: 13, // role
        tactics: 12, // role
        focus: 14, // star
        usage: 1.1,
        age: 29,
        potential: 17,
        tendencies: { points: 13, rebounds: 6, assists: 11 },
        mech: {
          class: 'SNIPER',
          model: 'HEXAGON-ARC9.SNIPER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 14, // star
          servoResponse: 12, // role
          jumpJets: 11, // role
          armor: 10, // role
          heatManagement: 12, // role
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'pa-p3',
        name: '[RDCTD]-C1',
        position: 3,
        reaction: 12, // role
        tactics: 13, // role
        focus: 12, // role
        usage: 1.0,
        age: 26,
        potential: 14,
        tendencies: { points: 11, rebounds: 10, assists: 9 },
        mech: {
          class: 'PHANTOM',
          model: 'FULCRUM-STRUT4.PHANTOM',
          manufacturer: 'Fulcrum Industries',
          targeting: 12, // role
          servoResponse: 12, // role
          jumpJets: 12, // role
          armor: 10, // role
          heatManagement: 11, // role
          wear: 7,
          durability: 18
        }
      },
      {
        id: 'pa-p4',
        name: '[RDCTD]-D6',
        position: 4,
        reaction: 11, // role
        tactics: 11, // role
        focus: 11, // role
        usage: 0.9,
        age: 25,
        potential: 15,
        tendencies: { points: 9, rebounds: 12, assists: 8 },
        mech: {
          class: 'ENFORCER',
          model: 'TANGENT-DELTA5.ENFORCER',
          manufacturer: 'Tangent Corporation',
          targeting: 11, // role
          servoResponse: 11, // role
          jumpJets: 11, // role
          armor: 11, // role
          heatManagement: 10, // minor weakness
          wear: 14,
          durability: 10
        }
      },
      {
        id: 'pa-p5',
        name: '[RDCTD]-E2',
        position: 5,
        reaction: 11, // role
        tactics: 10, // minor weakness
        focus: 11, // role
        usage: 0.8,
        age: 27,
        potential: 16,
        tendencies: { points: 10, rebounds: 13, assists: 7 },
        mech: {
          class: 'FORTRESS',
          model: 'PARALLAX-FILTER5.FORTRESS',
          manufacturer: 'Parallax Enterprises',
          targeting: 11, // role
          servoResponse: 11, // role
          jumpJets: 11, // role
          armor: 12, // role
          heatManagement: 11, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  },
  // Buffer Logistics Ltd (C tier, further buffed):
  {
    id: 'buffer-logistics',
    name: 'Buffer Logistics Ltd',
    abbreviation: 'BL',
    city: 'Corporate',
    color: '#ff8800',
    league: 'Corporate League',
    venue: 'Buffer Logistics Arena',
    volatility: 5,
    pace: 7, // Very methodical team
    shotPreference: 11, // Balanced shot selection
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'bl-p1',
        name: '[RDCTD]-A9',
        position: 1,
        reaction: 14, // star
        tactics: 13, // role
        focus: 12, // role
        usage: 1.2,
        age: 28,
        potential: 17,
        tendencies: { points: 13, rebounds: 9, assists: 12 },
        mech: {
          class: 'SUPPORT',
          model: 'TESSELLATE-PRISM2.SUPPORT',
          manufacturer: 'Tessellate Holdings',
          targeting: 13, // role
          servoResponse: 12, // role
          jumpJets: 11, // role
          armor: 12, // role
          heatManagement: 12, // role
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'bl-p2',
        name: '[RDCTD]-B3',
        position: 2,
        reaction: 12, // role
        tactics: 12, // role
        focus: 12, // role
        usage: 1.0,
        age: 29,
        potential: 18,
        tendencies: { points: 12, rebounds: 8, assists: 9 },
        mech: {
          class: 'STRIKER',
          model: 'VERTEX-ALPHA3.STRIKER',
          manufacturer: 'Vertex Solutions',
          targeting: 12, // role
          servoResponse: 12, // role
          jumpJets: 12, // role
          armor: 12, // role
          heatManagement: 11, // role
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'bl-p3',
        name: '[RDCTD]-C7',
        position: 3,
        reaction: 12, // role
        tactics: 12, // role
        focus: 11, // role
        usage: 0.9,
        age: 27,
        potential: 15,
        tendencies: { points: 11, rebounds: 11, assists: 8 },
        mech: {
          class: 'RANGER',
          model: 'MERIDIAN-COMPASS4.RANGER',
          manufacturer: 'Meridian Systems',
          targeting: 11, // role
          servoResponse: 11, // role
          jumpJets: 11, // role
          armor: 11, // role
          heatManagement: 11, // role
          wear: 7,
          durability: 18
        }
      },
      {
        id: 'bl-p4',
        name: '[RDCTD]-D2',
        position: 4,
        reaction: 11, // role
        tactics: 11, // role
        focus: 11, // role
        usage: 0.8,
        age: 26,
        potential: 16,
        tendencies: { points: 9, rebounds: 12, assists: 8 },
        mech: {
          class: 'GUARDIAN',
          model: 'FULCRUM-GIRDER4.GUARDIAN',
          manufacturer: 'Fulcrum Industries',
          targeting: 11, // role
          servoResponse: 11, // role
          jumpJets: 11, // role
          armor: 12, // role
          heatManagement: 10, // minor weakness
          wear: 5,
          durability: 2
        }
      },
      {
        id: 'bl-p5',
        name: '[RDCTD]-E8',
        position: 5,
        reaction: 11, // role
        tactics: 11, // role
        focus: 11, // role
        usage: 0.8,
        age: 28,
        potential: 17,
        tendencies: { points: 10, rebounds: 13, assists: 7 },
        mech: {
          class: 'DESTROYER',
          model: 'TANGENT-SIGMA5.DESTROYER',
          manufacturer: 'Tangent Corporation',
          targeting: 11, // role
          servoResponse: 11, // role
          jumpJets: 11, // role
          armor: 13, // role
          heatManagement: 11, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  },
  // Cache Ventures Inc: Streaky team, one star, rest role, 2 glaring weaknesses (e.g., rebounding, focus)
  {
    id: 'cache-ventures',
    name: 'Cache Ventures Inc',
    abbreviation: 'CV',
    city: 'Corporate',
    color: '#b0b0b0',
    league: 'Corporate League',
    venue: 'Cache Ventures Arena',
    volatility: 3,
    pace: 6, // Slowest team
    shotPreference: 17, // Heavy preference for 25s
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'cv-p1',
        name: '[RDCTD]-A2',
        position: 1,
        reaction: 12, // role
        tactics: 15, // star
        focus: 10, // minor weakness
        usage: 1.1,
        age: 26,
        potential: 15,
        tendencies: { points: 12, rebounds: 7, assists: 14 },
        mech: {
          class: 'COMMANDER',
          model: 'MERIDIAN-BEARING2.COMMANDER',
          manufacturer: 'Meridian Systems',
          targeting: 14, // star
          servoResponse: 12, // role
          jumpJets: 10, // role
          armor: 9, // minor weakness
          heatManagement: 12, // role
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'cv-p2',
        name: '[RDCTD]-B4',
        position: 2,
        reaction: 11, // role
        tactics: 12, // role
        focus: 14, // star
        usage: 1.0,
        age: 25,
        potential: 14,
        tendencies: { points: 13, rebounds: 6, assists: 10 },
        mech: {
          class: 'SNIPER',
          model: 'HEXAGON-ARC6.SNIPER',
          manufacturer: 'Hexagon Dynamics',
          targeting: 15, // star
          servoResponse: 12, // role
          jumpJets: 11, // role
          armor: 8, // minor weakness
          heatManagement: 13, // role
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'cv-p3',
        name: '[RDCTD]-C5',
        position: 3,
        reaction: 10, // minor weakness
        tactics: 13, // role
        focus: 11, // role
        usage: 1.0,
        age: 27,
        potential: 13,
        tendencies: { points: 10, rebounds: 8, assists: 8 },
        mech: {
          class: 'RANGER',
          model: 'PARALLAX-SCOPE2.RANGER',
          manufacturer: 'Parallax Enterprises',
          targeting: 12, // role
          servoResponse: 12, // role
          jumpJets: 13, // role
          armor: 9, // minor weakness
          heatManagement: 10, // role
          wear: 14,
          durability: 10
        }
      },
      {
        id: 'cv-p4',
        name: '[RDCTD]-D7',
        position: 4,
        reaction: 10, // role
        tactics: 9, // minor weakness
        focus: 12, // role
        usage: 0.9,
        age: 26,
        potential: 14,
        tendencies: { points: 7, rebounds: 13, assists: 7 },
        mech: {
          class: 'GUARDIAN',
          model: 'FULCRUM-TRUSS2.GUARDIAN',
          manufacturer: 'Fulcrum Industries',
          targeting: 11, // role
          servoResponse: 10, // role
          jumpJets: 12, // role
          armor: 14, // star
          heatManagement: 10, // role
          wear: 14,
          durability: 10
        }
      },
      {
        id: 'cv-p5',
        name: '[RDCTD]-E4',
        position: 5,
        reaction: 11, // role
        tactics: 8, // weakness
        focus: 10, // minor weakness
        usage: 0.8,
        age: 27,
        potential: 15,
        tendencies: { points: 8, rebounds: 10, assists: 6 },
        mech: {
          class: 'ASSAULT',
          model: 'TANGENT-ALPHA2.ASSAULT',
          manufacturer: 'Tangent Corporation',
          targeting: 10, // role
          servoResponse: 9, // weakness
          jumpJets: 12, // role
          armor: 15, // star
          heatManagement: 11, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  },
  // Matrix Solutions Inc (A/B tier):
  {
    id: 'matrix-solutions',
    name: 'Matrix Solutions Inc',
    abbreviation: 'MS',
    city: 'Corporate',
    color: '#8888ff',
    league: 'Corporate League',
    venue: 'Matrix Solutions Arena',
    volatility: 14,
    pace: 15, // High-tempo team
    shotPreference: 7, // Prefers 10s but willing to take 25s
    wins: 0,
    losses: 0,
    pilots: [
      {
        id: 'ms-p1',
        name: '[RDCTD]-A5',
        position: 1,
        reaction: 14, // star
        tactics: 17, // superstar
        focus: 12, // role
        usage: 1.2,
        age: 27,
        potential: 16,
        tendencies: { points: 14, rebounds: 7, assists: 16 },
        mech: {
          class: 'SUPPORT',
          model: 'TESSELLATE-PRISM3.SUPPORT',
          manufacturer: 'Tessellate Holdings',
          targeting: 15, // star
          servoResponse: 13, // role
          jumpJets: 11, // role
          armor: 10, // role
          heatManagement: 13, // role
          wear: 20,
          durability: 19
        }
      },
      {
        id: 'ms-p2',
        name: '[RDCTD]-B6',
        position: 2,
        reaction: 14, // star
        tactics: 13, // role
        focus: 15, // star
        usage: 1.1,
        age: 28,
        potential: 16,
        tendencies: { points: 15, rebounds: 6, assists: 12 },
        mech: {
          class: 'STRIKER',
          model: 'VERTEX-ALPHA4.STRIKER',
          manufacturer: 'Vertex Solutions',
          targeting: 16, // star
          servoResponse: 13, // role
          jumpJets: 12, // role
          armor: 10, // role
          heatManagement: 13, // role
          wear: 20,
          durability: 3
        }
      },
      {
        id: 'ms-p3',
        name: '[RDCTD]-C2',
        position: 3,
        reaction: 13, // role
        tactics: 13, // role
        focus: 12, // role
        usage: 1.0,
        age: 26,
        potential: 14,
        tendencies: { points: 10, rebounds: 10, assists: 8 },
        mech: {
          class: 'PHANTOM',
          model: 'HEXAGON-ARC6.PHANTOM',
          manufacturer: 'Hexagon Dynamics',
          targeting: 13, // role
          servoResponse: 13, // role
          jumpJets: 13, // role
          armor: 10, // role
          heatManagement: 12, // role
          wear: 14,
          durability: 10
        }
      },
      {
        id: 'ms-p4',
        name: '[RDCTD]-D3',
        position: 4,
        reaction: 12, // role
        tactics: 10, // minor weakness
        focus: 12, // role
        usage: 0.9,
        age: 25,
        potential: 15,
        tendencies: { points: 7, rebounds: 13, assists: 7 },
        mech: {
          class: 'ENFORCER',
          model: 'FULCRUM-STRUT2.ENFORCER',
          manufacturer: 'Fulcrum Industries',
          targeting: 12, // role
          servoResponse: 11, // role
          jumpJets: 12, // role
          armor: 14, // star
          heatManagement: 11, // role
          wear: 14,
          durability: 10
        }
      },
      {
        id: 'ms-p5',
        name: '[RDCTD]-E7',
        position: 5,
        reaction: 12, // role
        tactics: 9, // minor weakness
        focus: 12, // role
        usage: 0.8,
        age: 27,
        potential: 16,
        tendencies: { points: 9, rebounds: 14, assists: 6 },
        mech: {
          class: 'FORTRESS',
          model: 'PARALLAX-FILTER3.FORTRESS',
          manufacturer: 'Parallax Enterprises',
          targeting: 12, // role
          servoResponse: 11, // role
          jumpJets: 13, // role
          armor: 16, // star
          heatManagement: 12, // role
          wear: 14,
          durability: 10
        }
      }
    ]
  }
];

export const getTeamById = (id) => teams.find(team => team.id === id); 